import React, { useEffect, useRef, useState } from 'react';
import {
	ChartWrapper,
	TitleSection,
	TopContentWrapper,
	Wrapper,
} from '../shared.styles';
import { getLastConsultantDeliveirty } from '@/API/repositories/reports';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import CustomSkeleton from '@/common/components/CustomSkeleton';
import SelectInput from '@/common/components/SelectInput';
import Input from '@/common/components/Input';
import CustomLine from '@/common/charts/Line';
import { Colors } from '@/common/colors/colors';
import moment from 'moment';
import Icon from '@/common/components/Icon';

const TIME_TO = moment().weekday() > 4 ? 1 : 2;

const DeliveryConsultant = () => {
	const [chartData, setChartData] = useState();
	const {
		options: { queuesOptions },
	} = useCommonDataContext();
	const timeRangeRef = useRef();
	const sentRef = useRef();

	const [selectedMarket, setSelectedMarket] = useState(queuesOptions[0]);

	const { makeRequest } = useRequestsContext();

	const handleLoadData = async () => {
		setChartData(() => null);

		const payload = {};
		payload.consultants = selectedMarket.value.consultants;
		payload.timeFrom = timeRangeRef.current.value;
		payload.timeTo = TIME_TO;
		payload.isSent = sentRef.current?.checked;

		const response = await makeRequest(
			getLastConsultantDeliveirty.bind(null, payload),
		);

		if (response.data) {
			setChartData(() => response.data);
		}
	};

	useEffect(() => {
		if (queuesOptions[0] && selectedMarket) {
			handleLoadData();
		}
	}, [queuesOptions, selectedMarket]);

	useEffect(() => {
		if (queuesOptions[0]) {
			setSelectedMarket(() => queuesOptions[0]);
		}
	}, [queuesOptions]);

	return (
		<Wrapper width={800}>
			<TitleSection>
				<TopContentWrapper>
					<Icon name='usps' />
					Weekly consultant delivery
				</TopContentWrapper>
				<TopContentWrapper>
					<Input
						inputRef={sentRef}
						name='sent'
						type='checkbox'
						inputWidth={20}
						width={30}
						color={Colors.darkBlue}
					/>
					<Input
						showLabel={false}
						inputWidth={50}
						value={TIME_TO}
						inputRef={timeRangeRef}
					/>
					<SelectInput
						options={queuesOptions}
						selected={selectedMarket}
						setSelected={setSelectedMarket}
						selectWidth={200}
						showLabel={false}
					/>
					<Icon
						name='refresh'
						className='animation-scale'
						style={{ cursor: 'pointer' }}
						onClick={() => handleLoadData()}
					/>{' '}
				</TopContentWrapper>
			</TitleSection>
			<ChartWrapper>
				{chartData ? (
					<CustomLine
						data={chartData}
						options={{
							scales: {
								y: {
									type: 'linear',
									display: true,
									position: 'left',
								},
							},
						}}
					/>
				) : (
					<CustomSkeleton width={750} count={16} height={5} />
				)}
			</ChartWrapper>
		</Wrapper>
	);
};

export default DeliveryConsultant;
